module.exports = __webpack_public_path__ + "static/img/PNG-path1-1.1112d6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/SVG-filer/PNG-path1-1.png
// module id = aig8
// module chunks = 1